module.exports = __webpack_public_path__ + "img/medicine melancholy_sc2.6997787e.png";